import styled, { css } from "styled-components/native";
import { pickStyle as _, pickThemeKey as theme } from "utils";
import {
  ContainerWidth,
  ConatinerMargin,
  FontSize,
  ButtonPadding,
  DescriptionFont,
  DescriptionFontMaxWidth,
  RatingButtonWidthLarge,
  RatingButtonWidth,
} from "./variables";

export const Container = styled.View`
  width: ${_(ContainerWidth) || "100%"};
  ${props =>
    props.$compact
      ? css`
          margin-top: 0px;
        `
      : css`
          margin-top: ${_(ConatinerMargin) || 90}px;
        `}
  margin-bottom: ${props => (props.$hasDescription ? 100 : 80)}px;
  align-self: center;
`;

export const Wrapper = styled.View`
  flex-direction: row;
  border: 2px ${theme("score_border")};
  border-radius: 4px;
  align-self: center;
  flex-shrink: unset;
  flex-basis: unset;
`;

export const RatingButtons = styled.View`
 ${props =>
   props.$large
     ? css`
         width: ${_(RatingButtonWidthLarge) || 120}px;
       `
     : css`
         width: ${_(RatingButtonWidth) || 80}px;
       `}
  background-color: ${props =>
    props.$isSelected
      ? theme("score_background_selected")(props)
      : "score_background"};
  align-items: center;
  justify-content: center;
  border-left-width: ${({ $index }) => ($index === 0 ? 0 : 1)}px;
  border-left-color: ${theme("score_border")};
`;

export const RatingButton = styled.TouchableOpacity`
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const NumberText = styled.Text`
  font-size: ${_(FontSize) || 25}px;
  font-weight: ${props => (props.$isSelected ? 600 : 100)};
  color: ${props =>
    props.$isSelected
      ? theme("score_text_selected")(props)
      : theme("score_text")(props)};
  padding: ${_(ButtonPadding) || 12}px 0;
`;

export const DescriptionText = styled.Text`
  font-size: ${theme("nps_description_size") || _(DescriptionFont) || 18}px;
  color: ${theme("score_description")};
  text-align: center;
  align-self: center;
  max-width: ${_(DescriptionFontMaxWidth) || 135}px;
`;

export const ScoreDescription = styled.View`
  position: absolute;
  top: 52px;
  width: 150px;
`;

export const DescriptionLine = styled.View`
  border-left-color: ${theme("score_description_line")};
  border-left-width: 1px;
  height: 34px;
  width: 4.5%;
  margin-left: 49%;
`;
